import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import api from "../../api/apiClient";
import { SearchResponseDto } from "../../types/modules/search.type";
import { RootState } from "../../redux/store";

interface UseGlobalSearchParams {
    keyword?: string;
    page?: number;
    enabled?: boolean;
}

export const useGlobalSearch = ({
    keyword = '',
    page = 1,
    enabled = true,
}: UseGlobalSearchParams = {}) => {
    const { role } = useSelector((state: RootState) => state.auth);

    return useQuery({
        queryKey: ["global-search", keyword, page],
        queryFn: async () => {
            if (!keyword || keyword.trim().length < 2) {
                return { data: [], page };
            }
            const response = await api.get<SearchResponseDto>(
                `/search?keyword=${encodeURIComponent(keyword)}&page=${page}`
            );
            return response.data;
        },
        enabled: enabled && keyword.trim().length >= 2 && role === "ADMIN",
        staleTime: 1000 * 60 * 5,
    });
};
